import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    ariaLabel: (projectName: string) => string;
    scopeLabel: string;
    allProjectsLabel: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Label for the project scope pill */
            ariaLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (projectName: string): string => __intl__.intl().formatMessage({ id: "ProjectScopeDropdown.ariaLabel?c=1ig49iqheh8r", defaultMessage: "Search scope options for {projectName}" }, { projectName: projectName }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the location group in the dropdown */
            scopeLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectScopeDropdown.scopeLabel?c=337hmpljp5swm", defaultMessage: "Location" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Label for the all-projects scope option */
            allProjectsLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "ProjectScopeDropdown.allProjectsLabel?c=1s4rel3o4dxvr", defaultMessage: "All Projects" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
